module.exports = __webpack_public_path__ + "img/3.3ebf47a0.jpg";